import { IHttpClient } from '@wix/http-client';
import {
  priceQuotesApiUrl,
  priceQuotesApiUrlWithoutAPIPrefix,
} from '../../../constants';

const extract = <T>({ data }: { data: T }) => data;

export default class Actions {
  private priceQuotesApiUrl: string;

  constructor(
    private token: string,
    private instanceId: string,
    private priceQuoteId: string,
    private client: IHttpClient,
  ) {
    this.priceQuotesApiUrl = window.__CONSENT_POLICY_ENABLED__
      ? priceQuotesApiUrlWithoutAPIPrefix
      : priceQuotesApiUrl;
  }

  public async accept() {
    const {
      id: { version },
    } = await this.client
      .post<any>(`${this.priceQuotesApiUrl}/${this.priceQuoteId}/0/view`, {
        token: this.token,
        instanceId: this.instanceId,
        priceQuoteId: this.priceQuoteId,
      })
      .then(extract);

    return this.client
      .post<any>(
        `${this.priceQuotesApiUrl}/${this.priceQuoteId}/${version}/uou-accept`,
        {
          token: this.token,
          instanceId: this.instanceId,
        },
      )
      .then(extract);
  }

  public get(): Promise<any> {
    return this.client
      .post<any>(`${this.priceQuotesApiUrl}/${this.priceQuoteId}/0/view`, {
        token: this.token,
        instanceId: this.instanceId,
        priceQuoteId: this.priceQuoteId,
      })
      .then(extract)
      .then(({ businessInfo, status, data: priceQuote }) => ({
        businessInfo,
        priceQuote: { ...priceQuote, status },
      }));
  }

  public pdfUrl = ({ urlPrefix }: { urlPrefix: string }) =>
    `${urlPrefix}/price-quote/${this.instanceId}:${this.priceQuoteId}/pdf/view`;
}
